module.exports = __webpack_public_path__ + "img/certificate_221320116_00.5d694a0d.jpg";